function formatAbbrev(n: number, decimals = 1): string {
  const abs = Math.abs(n);
  const sign = n < 0 ? "-" : "";

  const cutTo = (v: number) => {
    const f = Math.pow(10, decimals);
    return Math.floor(v * f) / f;
  };
  const stripZeros = (s: string) => s.replace(/\.0+$|(\.\d*[1-9])0+$/, "$1");

  if (abs >= 1_000_000) {
    const v = cutTo(abs / 1_000_000);
    return sign + stripZeros(v.toFixed(decimals)) + " m";
  }
  if (abs >= 1_000) {
    const v = cutTo(abs / 1_000);
    return sign + stripZeros(v.toFixed(decimals)) + " k";
  }
  return String(n);
}

export function formatRange(
  a?: string | number | undefined,
  b?: string | number | undefined,
): string {
  if (!a && !b) return "";
  if (!a && b) return `1 - ${formatAbbrev(Number(b))}`;
  if (a && !b) return `${formatAbbrev(Number(a))}`;

  const from = Math.min(a as number, b as number);
  const to = Math.max(a as number, b as number);
  return `${formatAbbrev(from)} - ${formatAbbrev(to)}`;
}
